import { createAction } from "@reduxjs/toolkit";
import { Merchant } from "../../../bos_common/src/types/MerchantType";

export const merchantFetchSucceed = createAction<Merchant>('merchant/updateMerchant');
export const updateMerchantSucceed = createAction<Merchant>('merchant/updateMerchant');